export default __webpack_public_path__ + "static/media/PA.350b79e3.svg";